import { Info } from "lucide-react";

interface WebstoreNotesProps {
  notes: string[];
}

/**
 * Caveats that change how the numbers should be read.
 *
 * Supplied by the API rather than hard-coded here, so the reasons live next to the
 * code that knows whether they currently apply — the "no country data" note only
 * appears when a real share of visits is missing one.
 */
export function WebstoreNotes({ notes }: WebstoreNotesProps) {
  if (notes.length === 0) return null;

  return (
    <div className="panel p-5">
      <div className="flex items-center gap-2 mb-3">
        <Info className="h-3.5 w-3.5 text-slate-400" />
        <div className="text-xs font-bold uppercase tracking-wider text-slate-500">
          How to read this
        </div>
      </div>
      <ul className="space-y-2 text-[11px] leading-relaxed text-slate-600">
        {notes.map((note, index) => (
          <li key={index} className="flex gap-2">
            <span className="text-slate-300 select-none">·</span>
            <span>{note}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
